import { CopyOutlined } from '@ant-design/icons';
import { Dropdown, message } from 'antd';
import type { ReactElement } from 'react';

export async function copyUserId(userId: string) {
  try {
    await navigator.clipboard.writeText(userId);
    message.success('UID 已复制');
  } catch {
    message.error('复制失败，请允许浏览器访问剪贴板后重试');
  }
}

export function UserIdMenu({
  userId,
  owner = false,
  children,
}: {
  userId?: string;
  owner?: boolean;
  children: ReactElement;
}) {
  if (!userId) return children;
  return (
    <Dropdown
      trigger={['contextMenu']}
      menu={{
        items: [
          {
            key: 'copy-user-id',
            icon: <CopyOutlined aria-hidden="true" />,
            label: owner ? '复制所属用户 UID' : '复制 UID',
            onClick: () => void copyUserId(userId),
          },
        ],
      }}
    >
      {children}
    </Dropdown>
  );
}
